import { Form } from '../Form/Form'
import { ChooseSitesProps } from './Types'
import Styles from './SEOPlanningWizard.module.scss'
import { Button } from 'blaze-ui/Button'
import { ArrowLeft, ArrowRight } from 'almanac-ui/icons'
import { OrganicResult } from './SerpResponseType'
import { SiteResult } from './SiteResult'
import { Text } from 'blaze-ui/Text/Text'
import { Heading } from 'blaze-ui/Heading/Heading'
import { SitesLoadingState } from './SitesLoadingState'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export const ChooseSites = ({
  searchResultsMutation,
  selectedWebsites,
  setSelectedWebsites,
  onSubmit,
  goBack,
}: ChooseSitesProps) => {
  const { isMobile } = useResponsiveDesign()

  const handleSiteSelect = (site: OrganicResult, isSelected: boolean) => {
    if (isSelected) {
      setSelectedWebsites([...selectedWebsites, site])
    } else {
      setSelectedWebsites(selectedWebsites.filter((website) => site.link !== website.link))
    }
  }

  const serpResponse = searchResultsMutation.data

  return (
    <Form.Root>
      <Form.Section>
        <Form.SectionContent>
          <Form.Fields>
            <>
              <div className={Styles.header}>
                <Heading level={4}>Select Reference Articles</Heading>
                <Text variant="secondary">
                  Choose up to 3 reference articles to help Blaze identify keyword opportunities and ideal article
                  structure for your blogs.
                </Text>
              </div>
              {searchResultsMutation.isLoading && <SitesLoadingState />}
              {!searchResultsMutation.isLoading && serpResponse && (
                <div className={Styles.siteResults}>
                  {serpResponse.organic_results.map((result) => (
                    <SiteResult
                      key={result.link}
                      site={result}
                      selectedWebsites={selectedWebsites}
                      onSiteSelect={handleSiteSelect}
                    />
                  ))}
                </div>
              )}
            </>
          </Form.Fields>
        </Form.SectionContent>
      </Form.Section>

      <Form.Actions isSticky>
        {!isMobile && <Form.PreviousButton onPress={goBack}>Set Topic</Form.PreviousButton>}
        <Form.PrimaryActions>
          <Button
            size="lg"
            onPress={onSubmit}
            endIcon={ArrowRight}
            isDisabled={selectedWebsites.length === 0}
            fullWidth={isMobile}
          >
            Generate Keywords
          </Button>
          {isMobile && (
            <Button frontIcon={ArrowLeft} variant="secondary" size="lg" onPress={goBack} fullWidth={isMobile}>
              Set Topic
            </Button>
          )}
        </Form.PrimaryActions>
      </Form.Actions>
    </Form.Root>
  )
}
